import React from 'react';
import { useCurrency } from '../currency/Currency';
import './product-price.css';
export default function ProductPrice({price,compareAtPrice}:{price:number;compareAtPrice?:number|null}) {
  const {money}=useCurrency();
  const sale=typeof compareAtPrice==='number' && Number.isFinite(compareAtPrice) && compareAtPrice>price && price>0;
  return <span className="product-price">{sale&&<><del aria-label="Regular price">{money(compareAtPrice!)}</del><span className="product-sale-label">Sale</span></>}<span>{money(price)}</span></span>;
}
